// React
import React from 'react';

// Components
import LeftHexSecondHome from '../SecondSection/components/SideHexagons/LeftHexSecondHome';
import HomeLinkButton from '../../HomeLinkButton';

// Icons
import { PlayIcon } from 'components/Icons';

// Style
import './style.sass';

// Images
/**
  const leftIcon = require('assets/images/NewDesign/Home/second-section/icon-left.png');
  const rightIcon = require('assets/images/NewDesign/Home/second-section/icon-right.png');
  const bgIcons = require('assets/images/NewDesign/Home/second-section/bg-second-icons.png');
*/
const videoPlayerBg = require('assets/images/NewDesign/Home/second-section/bg-video-embed.jpg');
const videoPlayButton = require('assets/images/icons/play-c1.svg');

class SecondSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      videoLink: '',
    };

    this.sectionElements = React.createRef();
  }

  componentDidMount = () => {
    /**
      gsap.registerPlugin(ScrollTrigger);
      const tlFirst = gsap.timeline({
          scrollTrigger: {
              trigger: this.sectionElements.current,
              start: "top 75%",
              end: "top ",
              scrub: 2,
          }
      });
      tlFirst.from(this.sectionElements.current, {opacity: 0, duration: 2});
    */

    this.documentLanguage();
  };

  documentLanguage = () => {
    const locale = localStorage.getItem('locale');
    const videoLinkId =
      locale == 'es' ? 'xvx2k7d4nzfqxthg' : 'msjstjuuipyd9h8z';

    this.setState({
      videoLink: `https://docsend.com/view/${videoLinkId}`,
    });
  };

  render() {
    const { t, href } = this.props;
    const { videoLink } = this.state;

    return (
      <div className="second-section-wrapper" ref={this.sectionElements}>
        <LeftHexSecondHome />
        <div className="content-container">
          <div className="section-text">
            <p>{t('c1do1Black.secondSection.firstText')}</p>
          </div>
          <div className="second-section-video-container">
            <div className="second-section-video-play">
              <a href={videoLink} target="_blank" rel="noopener noreferrer">
                <div
                  className="video-play-button"
                  style={{
                    backgroundImage: `url(${videoPlayButton})`,
                  }}
                ></div>
              </a>
            </div>
            <div
              className="second-section-video-bg"
              style={{
                backgroundImage: `url(${videoPlayerBg})`,
              }}
            ></div>
            <div className="second-section-video-text">
              <h1>C1DO1</h1>
              <p>{t('c1do1Black.secondSection.videoSection.description')}</p>
              <div className="second-section-credits">
                <p>Julián Vargas Cohen</p>
                <p>CEO & Founder</p>
              </div>
            </div>
          </div>
          {/* <div className='icons-content'>
            <div className='left-element-container'>
              <div
                className='element'
                // style={{ backgroundImage: `url(${bgIcons})` }}
              >
                <img src={leftIcon} className='icon' alt=''/>
              </div>
              <div className="second-section-text">
                <p>{t('c1do1Black.secondSection.secondText')}</p>
              </div>

            </div>
            <div className='right-element-container'>
              <div
                className='element'
                // style={{ backgroundImage: `url(${bgIcons})` }}
              >
                <img src={rightIcon} className='icon' alt=''/>
              </div>
              <p>{t('c1do1Black.secondSection.thirdText')}</p>
            </div>
          </div> */}
        </div>
        <HomeLinkButton t={t} href={href} />
      </div>
    );
  }
}

export default SecondSection;
